var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{},[_c('b-tabs',{attrs:{"lazy":"","fill":"","justified":"","value":_vm.activeTab},on:{"activate-tab":_vm.changeTab}},[_c('b-tab',{attrs:{"title":"Thiết bị"}},[_c('ListDevices')],1),_c('b-tab',{attrs:{"title":"Thiết bị Tingbox"}},[_c('ListDeviceTingBox')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }